import to from 'await-to-js'
import { createStableImageBitmap } from '@/helpers/image'

let supportsPositionSticky = null

export function isPositionStickySupported() {
  if (supportsPositionSticky === null) {
    const testNode = document.createElement('div')

    supportsPositionSticky = ['', '-webkit-'].some(prefix => {
      try {
        testNode.style.position = prefix + 'sticky'
      } catch (e) {} // eslint-disable-line no-empty

      return testNode.style.position != ''
    })
  }
  return supportsPositionSticky
}

function isObjectFitSupported() {
  return (
    // see: https://caniuse.com/#search=object-fit
    'objectFit' in document.documentElement.style !== false && !isEdgeVersionLET(18)
  )
}

export async function objectFit(elements) {
  if (!isObjectFitSupported()) {
    const [error, module] = await to(
      import(/* webpackChunkName: "npm__object-fit-polyfill" */ 'objectFitPolyfill')
    )
    if (!error && module) window.objectFitPolyfill(elements)
  }
}

const getUA = () => window.navigator.userAgent
export const isIPhone = Boolean(getUA().match(/(iPhone)/))

export const isIOS = /iPad|iPhone|iPod/.test(getUA()) && !window.MSStream

/**
 * Checks if current browser is Edge and
 * has a version number that is lower or equal than (LET) the version number to compare.
 *
 * @param {Number} versionNumberToCompare
 */
export const isEdgeVersionLET = versionNumberToCompare => {
  const ua = getUA()
  const edge = ua.indexOf('Edge/')
  if (edge > 0) {
    const verionsNumber = parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10)
    return verionsNumber <= versionNumberToCompare
  }
  return false
}

/**
 * @see https://davidwalsh.name/detect-webp
 */
export async function isWebpImageSupported() {
  if (!self.fetch) return false
  if (isWebpImageSupported.promise) return isWebpImageSupported.promise

  const webpData = 'data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAAAAAAfQ//73v/+BiOh/AAA='
  const blob = await fetch(webpData).then(
    response => response.blob(),
    () => (isWebpImageSupported.promise = Promise.resolve(false)) // for IE 11 with fetch polyfill
  )
  if (!isWebpImageSupported.promise) {
    isWebpImageSupported.promise = createStableImageBitmap(blob).then(
      () => true,
      () => false
    )
  }
  return isWebpImageSupported.promise
}
